export default __webpack_public_path__ + "static/media/Study Material.66a9d958.svg";